import EnhancedTab from 'lib/designSystem/TabSimulation';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import PurchaseOrders from './components/PurchaseOrders';
import Tenders from './components/Tenders';
import SupplierStats from './components/TendersStats';

const PublicMarket: React.FC = () => {
  const { id } = useParams<{ id: string; page: string }>();
  const navigate = useNavigate();

  const tabs = [
    {
      id: 1,
      label: 'Estadísticas',
      component: <SupplierStats id={id} />,
      path: 'stats',
    },
    {
      id: 2,
      label: 'Licitaciones',
      component: <Tenders />,
      path: 'tenders',
    },
    {
      id: 3,
      label: 'Ordenes de compra',
      component: <PurchaseOrders />,
      path: 'purchaseOrders',
    },
  ];

  const handleNavigation = (index: number) => {
    if (!id) return;
    navigate(`/companies/${id}/publicMarket/${tabs[index].path}`);
  };

  return (
    <EnhancedTab
      tabType="secondary"
      tabs={tabs}
      onTabChange={handleNavigation}
    />
  );
};

export default PublicMarket;
